import { useState } from "react";
import { useRouter } from "@/_router";
import { ChevronLeftIcon } from "@/components/Icons";
import WebContainer from "@/components/WebContainer";
import LegalContent from "@/components/LegalContent";

export default function Legal() {
  const router = useRouter();
  const [isScrolled, setIsScrolled] = useState(false);

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    setIsScrolled(e.currentTarget.scrollTop > 10);
  };

  return (
    <WebContainer className="fixed inset-0 bg-[var(--bg-primary)] text-[var(--text-primary)] flex flex-col font-sans overflow-hidden selection:bg-[var(--accent)]/20">
      <header
        className={`shrink-0 z-20 backdrop-blur-md transition-all duration-300 ${
          isScrolled ? "bg-[var(--bg-primary)]/80 shadow-sm" : "bg-transparent"
        }`}
      >
        <div className="px-5 py-4 flex items-center justify-between">
          <button
            onClick={() => router.back()}
            className="w-12 h-12 rounded-full flex items-center justify-center bg-[var(--glass-bg-hover)] backdrop-blur-md active:scale-90 transition-all text-[var(--text-primary)] hover:bg-[var(--glass-bg-active)]"
          >
            <ChevronLeftIcon size={26} />
          </button>
          <h1 className="text-[17px] font-medium tracking-wide text-[var(--text-primary)]/90">
            Legal
          </h1>
          <div className="w-12" />
        </div>
      </header>

      <main
        className="flex-1 px-5 py-6 relative z-10 overflow-y-auto pb-32"
        onScroll={handleScroll}
      >
        <div className="max-w-2xl mx-auto">
          <LegalContent />
        </div>
      </main>
    </WebContainer>
  );
}
